import * as PopoverPrimitive from "@radix-ui/react-popover";
import { cn } from "@stylingcv/utils";
import { forwardRef } from "react";

export const Popover = PopoverPrimitive.Root;

export const PopoverArrow = PopoverPrimitive.Arrow;

export const PopoverTrigger = PopoverPrimitive.Trigger;

export const PopoverContent = forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, align = "center", sideOffset = 6, ...props }, ref) => (
  <PopoverPrimitive.PopoverPortal>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(
        "z-50 w-[calc(100vw-2rem)] max-w-[90vw] rounded border bg-background p-3 shadow-sm outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 sm:w-auto sm:max-w-md sm:p-4",
        className,
      )}
      {...props}
    />
  </PopoverPrimitive.PopoverPortal>
));

PopoverContent.displayName = PopoverPrimitive.Content.displayName;
